import { Box, Typography } from "@mui/material";
import { faTriangleExclamation } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ReactHtmlParser from "react-html-parser";
import type ArticleRelatedArticle from "@/src/_types/Article/article-related-article";

const ArticleRelatedArticles = (
    {
        relatedArticles,
        sourceRelatedArticles
    }: {
        relatedArticles: ArticleRelatedArticle[],
        sourceRelatedArticles: ArticleRelatedArticle[]
    }
) => (
    <Box
        display="flex"
        flexDirection="column"
        gap={.5}
        p={1}
        my={1}
        bgcolor="secondary.main"
        borderRadius={2}
        sx={{
            '& a': {
                textDecoration: 'none',
                color: 'custom.link',
                '&:hover': {
                    color: 'custom.hoverLink'
                }
            }
        }}
    >
        {
            relatedArticles.length > 0 &&
            relatedArticles.map((relatedArticle: ArticleRelatedArticle, index: number) => (
                <Box key={`related-article-${index}`}>
                    <Typography component="span" mr={.25}>
                        <FontAwesomeIcon
                            icon={ faTriangleExclamation }
                        />
                    </Typography>
                    {
                        ReactHtmlParser(relatedArticle.text)
                    }
                </Box>
            ))
        }
        {
            sourceRelatedArticles.length > 0 &&
            sourceRelatedArticles.map((sourceRelatedArticle: ArticleRelatedArticle, index: number) => (
                <Box key={`source-related-article-${index}`}>
                    <Typography component="span" mr={.25}>
                        <FontAwesomeIcon
                            icon={ faTriangleExclamation }
                        />
                    </Typography>
                    {
                        ReactHtmlParser(sourceRelatedArticle.text)
                    }
                </Box>
            ))
        }
    </Box>
)

export default ArticleRelatedArticles;